import React from 'react';
import { Icon } from '../../../components/ui/Icon/Icon';
import { MAX_URL } from '../../../data/config';
import styles from './ContactCard.module.scss';

/** Канал для срочных вопросов. Форма — основной канал, MAX — для срочного. */
export function ContactCard() {
  return (
    <div className={styles.call}>
      <span className={styles.eyebrow}>Срочный вопрос</span>

      <a className={styles.maxLink} href={MAX_URL} target="_blank" rel="noopener noreferrer">
        Перейти в MAX
        <span aria-hidden="true">↗</span>
      </a>

      <div className={styles.divider} />
      <p className={styles.always}>
        <Icon name="clock" size={14} />
        <span>
          Заявки через эту форму принимаются круглосуточно. Вне рабочих часов инженер ответит утром
          следующего рабочего дня.
        </span>
      </p>
    </div>
  );
}